import React from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import "./index.less";

export type ReportModalProps = {
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmationModal: React.FC<ReportModalProps> = ({ onClose, onConfirm }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => onClose?.();
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  const modalContent = (
    <div className="reasons-modal-overlay" onClick={handleOverlayClick}>
      <div className="reasons-modal-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>

        <div className="reasons-modal-container">
          <div className="reasons-modal-title">{t("confirm-report-title")}</div>
          <div className="reasons-modal-desc">{t("confirm-report-desc")}</div>

          <button
            type="button"
            className="reasons-actions-button"
            onClick={() => {
              onConfirm?.();
            }}
          >
            {t("confirm")}
          </button>
          <button
            type="button"
            className="reasons-actions-button cancel-button"
            onClick={() => {
              onClose?.();
            }}
          >
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default ConfirmationModal;
